import React, { PureComponent } from 'react';
import { BrowserRouter as Switch, Route, withRouter } from 'react-router-dom';

import CapacityPage from '../CapacityPage';

class App extends PureComponent {
  render () {
    return (
      <Switch>
        <Route exact path="/capacity">
          <CapacityPage />
        </Route>
      </Switch>
    )
  }
}

export default withRouter(App)
